function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.03,15.725a.787.787,0,1,0,1.113,1.112l2.622-2.622a.786.786,0,0,0,0-1.112L8.142,10.481A.787.787,0,1,0,7.03,11.593l1.881,1.88a.262.262,0,0,1,0,.371Z",
  transform: "translate(0.73 -0.728)",
  fill: "#097b41"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.587,15.823h4.2a.787.787,0,1,0,0-1.573h-4.2a.787.787,0,0,0,0,1.573Z",
  transform: "translate(1.322 -0.482)",
  fill: "#097b41"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.341,5.043A3.293,3.293,0,0,0,23.049,1.75H3.293A3.293,3.293,0,0,0,0,5.043V20.957A3.293,3.293,0,0,0,3.293,24.25H23.049a3.293,3.293,0,0,0,3.293-3.293ZM10.6,3.945a1.06,1.06,0,0,1,1.857,0,1.064,1.064,0,0,1,.169.549,1.064,1.064,0,0,1-.169.549,1.06,1.06,0,0,1-1.857,0,1.064,1.064,0,0,1-.169-.549,1.064,1.064,0,0,1,.169-.549Zm-3.841,0a1.06,1.06,0,0,1,1.857,0,1.064,1.064,0,0,1,.169.549,1.064,1.064,0,0,1-.169.549,1.06,1.06,0,0,1-1.857,0,1.064,1.064,0,0,1-.169-.549,1.064,1.064,0,0,1,.169-.549Zm-3.91.1a1.1,1.1,0,0,1,1-.65,1.081,1.081,0,0,1,.929.549,1.064,1.064,0,0,1,.169.549,1.064,1.064,0,0,1-.169.549,1.06,1.06,0,0,1-1.857,0,1.064,1.064,0,0,1-.169-.549,1.075,1.075,0,0,1,.1-.448Zm21.3,16.911a1.1,1.1,0,0,1-1.1,1.1H3.293a1.1,1.1,0,0,1-1.1-1.1V7.512a.274.274,0,0,1,.274-.274h21.4a.274.274,0,0,1,.274.274Z",
  transform: "translate(0 -1.75)",
  fill: "#39a95e"
});

var SvgFrontendDeveloper = function SvgFrontendDeveloper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.342,
    height: 22.5,
    viewBox: "0 0 26.342 22.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFrontendDeveloper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/frontend_developer.923f0ab3.svg";
export { ForwardRef as ReactComponent };